export interface Category {
  slug: string;
  name: string;
  icon: string;
  description: string;
}

export const categories: Category[] = [
  { slug: "lianai", name: "恋爱", icon: "ri-heart-3-fill", description: "甜蜜心动，初恋脸红心跳的纯爱故事" },
  { slug: "xiaoyuan", name: "校园", icon: "ri-graduation-cap-fill", description: "青春校园里的欢笑、友情与成长的烦恼" },
  { slug: "qihuan", name: "奇幻", icon: "ri-sparkling-2-fill", description: "魔法、异世界与天马行空的想象世界" },
  { slug: "dushi", name: "都市", icon: "ri-building-2-fill", description: "都市生活的情感纠葛与职场百态" },
  { slug: "rexue", name: "热血", icon: "ri-fire-fill", description: "燃到沸腾的冒险与少年热血之旅" },
  { slug: "xuanyi", name: "悬疑", icon: "ri-search-eye-fill", description: "层层反转、烧脑紧张的悬疑谜案" },
];